import React,{useState,useEffect} from 'react'
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom'

/*---------------------------------------
 404 page
---------------------------------------*/
import ErrorPage from './ErrorPage/error'
import Redirect404 from './ErrorPage/redirect'

/*---------------------------------------
 Pages Default
---------------------------------------*/
import ReservationComponent from './Reservations/index'


export default function RootComponent(props){

  const domain = "https://coffeeshophotel.ph";

  return (
    <React.Fragment>

          <header>
              <div className="wrapper">
                <div className="topHeader">
                  <ul className="socialMediaLinks">
                    <li>
                      <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                        <img src={domain+"/imgs/facebook.svg"} alt="Facebook icon. " title="Like Us on Facebook"/>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                        <img src={domain+"/imgs/instagram.svg"} alt="Instagram icon. " title="Follow us on Instagram"/>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.whatsapp.com/" target="_blank" rel="noreferrer">
                        <img src={domain+"/imgs/whatsapp.png"} alt="Whatsapp icon. " title="Message us on WhatsApp"/>
                      </a>
                    </li>
                  </ul>
                </div>

                <img className="logo" src={domain+"/imgs/logo.png"} alt="The Coffee Shop Logo. " title="The Coffee Shop Restaurant"/>

                <nav className="mainNav">
                  <ul>
                    <li>
                      <a href={domain}>Home</a>
                    </li>
                    <li>
                      <a href={domain+"/rooms-and-rates.php"}>Rooms &amp; Rates</a>
                    </li>
                    <li>
                      <a className='selectedLink' href={domain+"/hotel-reservation.php"}>Hotel Reservation</a>
                    </li>
                    <li>
                      <a href={domain+"/amenities-services.php"}>Amenities &amp; Services</a>
                    </li>
                    <li>
                      <a href={domain+"/restaurant.php"}>Restaurant</a>
                    </li>
                    <li>
                      <a href={domain+"/contact-us.php"}>Contact Us</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </header>

        
            <Routes>
               <Route path="/" element={<ReservationComponent />}/>
               {/* Page not found: 404 error */}
               <Route path="*" element={<Redirect404 />}/>

      			</Routes>


            <footer>
              <div className="lowerFooter">
                <div className="footer-right">
                    <p>#3 Rizal Street Corner National Highway, Barrio Barretto, Olongapo City</p>
                    <p>Tel. No.: (047) 222-0078 | CP. No.: (+63) 908-789-8308</p>
                    <p><a className="hvr-sweep-to-right" href="mailto:coffeeshopsrooftophotel23@gmail.com">coffeeshopsrooftophotel23@gmail.com</a> | <a className="hvr-sweep-to-right" href="mailto:reservations@coffeeshophotel.ph">reservations@coffeeshophotel.ph</a></p>
                </div>

                <div className="footer-left">
                  <p className="copyright"><a className="hvr-sweep-to-right" href={domain} target="_blank" rel="noreferrer">The Coffee Shop Rooftop Hotel and Restaurant, Olongapo City</a></p>
                  <p>Copyright &copy; All Rights Reserved.</p>
                  <nav>
                    <ul>
                      <li><a className="hvr-sweep-to-right" href={domain+"/terms-conditions.php"}>Terms and Conditions</a></li>
                      <li><a className="hvr-sweep-to-right" href={domain+"/privacy-policy.php"}>Privacy Policy</a></li>
                      <li><a className="hvr-sweep-to-right" href={domain+"/sitemap.php"}>Sitemap</a></li>
                    </ul>
                  </nav>
                  <a href={domain} target="_blank" rel='noreferrer'>
                    <img className="lgo" src={domain+"/imgs/lgo.png"} alt="Website Design and Development by Logicgateone Corp. " title="Website Design and Development by Logicgateone Corp."/>
                  </a>
                </div>
                <div className="clearboth"></div>
              </div>
            </footer>




    </React.Fragment>
  )
}
